/**
 * 所有类的基类
 */
export default class Base {
    /**
     * 构造函数
     * @param  {object}    options 可选参数
     * @return {undefined}
     */
    constructor(options) {
        this.setOptions(options);
    }

    /**
     * 设置可选参数
     * @param  {object}    options 可选参数
     * @return {undefined}
     */
    setOptions(options) {
        this.options = Object.assign(this.options || {}, options);
    }
}
